import React, { useRef, useState } from "react";
import "../styles/MasterPlanWithLegend.css";
import masterPlanImage from "../assets/palms-images/p.webp";
import masterPlanLegendData from "../data/palmsmasterPlanLegendData";

import { motion } from "framer-motion";


// ✅ Bottom → Top + fade + blur (premium)
const fadeUp = {
  hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.9, ease: "easeOut" },
  },
};

// ✅ Word by word animation (same as your H1)
const wordContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.15,
    },
  },
};

const wordVariant = {
  hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
  show: {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

// ✅ split title words
// ✅ remove starting space also
const line1 = "A Destination for".split(" ");
const line2 = "Refined Living".split(" ");

/* LEFT IMAGE */
const imageVariant = {
  hidden: {
    opacity: 0,
    filter: "blur(10px)",
    scale: 0.9,
  },
  show: {
    opacity: 1,
    filter: "blur(0px)",
    scale: 1,
    transition: {
      duration: 1.1,
      ease: "easeOut",
    },
  },
};

/* RIGHT LEGEND CONTAINER */
const legendContainer = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.2,
    },
  },
};

/* RIGHT LEGEND ITEM */
const legendItem = {
  hidden: {
    opacity: 0,
    y: 30,
    filter: "blur(6px)",
  },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};



export default function MasterPlanWithLegend() {
  const [activeId, setActiveId] = useState(null);
  const [openCategory, setOpenCategory] = useState("infrastructure");
  const planRef = useRef(null);

  const handleImageClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    console.log("LEFT:", x.toFixed(2), "TOP:", y.toFixed(2));
  };

  const handleLegendSelect = (itemId) => {
    setActiveId(itemId);

    if (window.innerWidth <= 991) {
      window.setTimeout(() => {
        if (!planRef.current) return;

        const rect = planRef.current.getBoundingClientRect();
        const viewportAnchor = window.innerHeight * 0.58;
        const targetTop = window.scrollY + rect.top - viewportAnchor;

        window.scrollTo({
          top: Math.max(targetTop, 0),
          behavior: "smooth",
        });
      }, 120);
    }
  };

  return (
    <section className="container-fluid p-5 position-relative" id="serene-legends"
      style={{ backgroundColor: "#bc73611c" }}>


      {/* Top Heading */}

      <div className="row g-4 align-items-start">



        {/* LEFT MASTER PLAN */}
        <div className="col-lg-8">
          {/* <motion.h1
            className="sage-title display-4"
            variants={wordContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.6 }}
          >
            {line1.map((word, i) => (
              <motion.span
                key={`line1-${i}`}
                variants={wordVariant}
                style={{ display: "inline-block", marginRight: "0.35em" }}
              >
                {word}
              </motion.span>
            ))}

            <br />

            {line2.map((word, i) => (
              <motion.span
                key={`line2-${i}`}
                variants={wordVariant}
                style={{ display: "inline-block", marginRight: "0.35em" }}
              >
                {word}
              </motion.span>
            ))}
          </motion.h1> */}
          <motion.div
            ref={planRef}
            className="mpl-planWrap position-relative overflow-hidden"
            variants={imageVariant}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.35 }}
          >

            <img
              src={masterPlanImage}
              alt="Master Plan"
              className="img-fluid w-100 d-block"
              onClick={handleImageClick}
            />

            {/* PINS */}
            {masterPlanLegendData.map((item) =>
              item.hotspots.map((spot, index) => (
                <div
                  key={`${item.id}-${index}`}
                  className="mpl-hotspot"
                  style={{
                    top: `${spot.top}%`,
                    left: `${spot.left}%`,
                  }}
                >
                  {activeId === item.id && (
                    <div className="mpl-pin">
                      <span className="mpl-pinNo">{item.id}</span>
                      <div className="mpl-tooltip">{item.title}</div>
                    </div>
                  )}
                </div>
              ))
            )}
          </motion.div>
        </div>

        {/* RIGHT LEGEND */}
        {/* RIGHT LEGEND (DESKTOP - UNCHANGED) */}
        <div className="col-lg-4 d-none d-lg-block">
          <div className="mpl-legendCard">
            <motion.div
              className="row g-2"
              variants={legendContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.35 }}
            >
              {masterPlanLegendData.map((item) => (
                <motion.div className="col-6" key={item.id} variants={legendItem}>
                  <button
                    type="button"
                    className={`mpl-legendItem w-100 text-start ${activeId === item.id ? "active" : ""}`}
                    onMouseEnter={() => setActiveId(item.id)}
                    onMouseLeave={() => setActiveId(null)}
                  >
                    <span className="mpl-legendNo">{item.id}.</span>
                    <span className="mpl-legendText">{item.title}</span>
                  </button>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>

        {/* MOBILE GROUPED LEGEND (ONE OPEN AT A TIME) */}
        <div className="col-12 d-block d-lg-none">
          <div className="mpl-mobileLegend">
            {["infrastructure", "landscape", "amenities", "water"].map((cat) => {
              const group = masterPlanLegendData.filter((i) => i.category === cat);
              if (!group.length) return null;

              return (
                <div key={cat} className="mpl-mobileGroup">
                  <button
                    type="button"
                    className={`mpl-mobileHeader ${openCategory === cat ? "open" : ""}`}
                    onClick={() => setOpenCategory(openCategory === cat ? null : cat)}
                  >
                    <span className="mpl-mobileIcon">{group[0].icon}</span>
                    <span className="mpl-mobileTitle">
                      {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </span>
                    <span className="mpl-mobileChevron">{openCategory === cat ? "−" : "+"}</span>
                  </button>

                  {openCategory === cat && (
                    <div className="mpl-mobileItems">
                      {group.map((item) => (
                        <button
                          key={item.id}
                          className={`mpl-mobileItem ${activeId === item.id ? "active" : ""}`}
                          onClick={() => handleLegendSelect(item.id)}
                        >
                          <span className="mpl-legendNo">{item.id}.</span>
                          <span className="mpl-legendText">{item.title}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
}
